import { createSelector } from '@reduxjs/toolkit';

import type { BaseAppState } from '../../types';
import { createEntityDenormalizer } from '../normalizers';

const denormalizeAsset = createEntityDenormalizer('assets');
const denormalizeSearchItem = createEntityDenormalizer('search_items');

export const selectAssetOrSearchItem = createSelector(
  [
    (state: BaseAppState, assetId: string) =>
      denormalizeAsset(state.entities, assetId),
    (state: BaseAppState, assetId: string) =>
      denormalizeSearchItem(state.entities, assetId),
  ],
  (asset, searchItem) => {
    return asset ?? searchItem;
  },
);

export const getAssetOrSearchItem = (
  state: BaseAppState,
  assetId: string | undefined,
) => {
  if (!assetId) {
    return undefined;
  }
  return state.entities.assets[assetId] ?? state.entities.search_items[assetId];
};
